import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const usePrevious = (value) => {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref.current;
};

const usePreviousLocation = () => {
  const location = useLocation();
  const previousLocation = usePrevious(location);
  return previousLocation;
};

export default usePreviousLocation;